<template>
    <div class="col-lg-12 mt-3">
        <div class="row">
            <div class="col-lg-12 d-flex justify-content-end">
                <button @click="AbrirModal" class="btn btn-primary">Agregar Material</button>
            </div>
            <div class="col-lg-12">
                <div class="table-responsive">
                    <table class="table align-items-center mb-0">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Nombre</th>
                                <th>Stock</th>
                                <th>Cantidad de Salida</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item,index) in ObjSolicitudSalida.Materiales" :key="index">
                                <td><button @click="EliminarMaterial(item.IdMaterial)" class="btn btn-danger"><i class="fa fa-trash"></i></button></td>
                                <td style="width:70%">{{ item.Nombre }}</td>
                                <td>{{ item.Stock }}</td>
                                <td><input type="text" class="form-control" v-model="item.Cantidad"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name:'Materiales',
    props:['pObjSolicitudSalida'],
    data() {
        return {
            ObjSolicitudSalida:{}
        }
    },
    methods: {
        AgregarMaterial(item){
            let ObjLista={
                IdMaterial:item.IdMaterial,
                Nombre:item.Nombre,
                Stock:item.Stock,
                Cantidad:1,
                Check:item.Check
            }
            this.ObjSolicitudSalida.Materiales.push(ObjLista);
        },
        EliminarMaterial(Id){
            let index=this.ObjSolicitudSalida.Materiales.findIndex((element)=>element.IdMaterial==Id);
            this.ObjSolicitudSalida.Materiales.splice(index,1);
        },
        AbrirModal(){
            this.bus.$emit('AbrirModalMaterial');
        }
    },
    created() {
        this.ObjSolicitudSalida=this.pObjSolicitudSalida;
        this.bus.$off('AgregarMaterialModal');
        this.bus.$on('AgregarMaterialModal',(obj)=>{
            this.AgregarMaterial(obj);
        })
    },
}
</script>

<style>

</style>